<template>
	<LayoutTableCommonRow class="font-code lh-xs align-top">
		<LayoutTableCommonPartRaw class="pe-1">
			<span v-tooltip:right="dateFormattedExtended">{{ dateFormatted }}</span>
		</LayoutTableCommonPartRaw>
		<LayoutTableCommonPartRaw class="px-1">
			{{ description }}
			<div class="text-break text-white-space vstack mt-1" v-if="transaction.observations">
				<b>Observaciones:</b>
				<span>{{ transaction.observations }}</span>
			</div>
		</LayoutTableCommonPartRaw>
		<LayoutTableCommonPartRaw class="ps-1 text-end">
			<span class="d-inline-block text-nowrap">{{ (transaction.type == 'income') ? '+' : '-' }} {{ vueNumberFormat(transaction.amount, { precision: 2 }) }} {{ currency }}</span>
		</LayoutTableCommonPartRaw>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';

	export default {
		props: {
			transaction: Object,
			currency: String
		},
		setup(props, { emit }) {
			const dateFormatted = computed(() => moment(props.transaction.created_at).format('DD/MM'));
			const dateFormattedExtended = computed(() => moment(props.transaction.created_at).format('LL'));
			const description = computed(() => {
				switch(props.transaction.transactionable_type) {
					case 'App\\Models\\SaleUser':
						if(props.transaction.transactionable?.sale?.number) return `Comisión por venta (Nro. ${props.transaction.transactionable.sale.number})`;
						else if(props.transaction.transactionable?.sale?.reference) return `Comisión por venta (Ref. ${props.transaction.transactionable.sale.reference})`;
						else return 'Comisión por venta';
						break;
					case 'App\\Models\\GoalPeriodUser':
						return `Comisión de "${props.transaction.transactionable.period.name}" en "${props.transaction.transactionable.period.goal.name}"`;
						break;
					default:
						return 'Pago registrado';
						break;
				}
			});

			return { dateFormatted, dateFormattedExtended, description };
		}
	}
</script>